module.exports = __webpack_public_path__ + "img/mj8-review.8357de53.png";